import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Homepage = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  // Slide data as a single <p> tag for easier editing
  const slides = [
    {
      id: 1,
      title: "For the Overlooked",
      description: (
        <p>
          Not every patient fits the mold. Black Sheep Development exists to support outliers, 
          because everyone deserves to be healthy, even the black sheep.
        </p>
      ),
      image: require('../static/images/slide_1.png'),
      textPosition: "left"
    },
    {
      id: 2,
      title: "Reduce Suffering",
      description: (
        <p>
          While others coast on yesterday's tools, we build for the patients who can't wait. Innovation shouldn't just be a buzz word, it's a duty. We engineer with urgency, precision, and purpose like lives depend on it.<br />
          <br/>
          Because they do.
        </p>
      ),
      image: require('../static/images/slide_2.png'),
      textPosition: "right"
    },
    {
      id: 3,
      title: "Black Sheep Development",
      description: (
        <p>
          Black Sheep Development was built to challenge complacency, to ask hard questions, and tackle hard problems. We work across species, disciplines, and boundaries to create solutions to the most complex challenges. Because new ideas won't come from going with the herd, they come from the black sheep.
        </p>
      ),
      image: require('../static/images/slide_3.png'),
      textPosition: "left"
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const slideHeight = window.innerHeight - 70; // Account for header height
      const currentSlide = Math.round(scrollY / slideHeight);
      setActiveSlide(Math.min(currentSlide, slides.length - 1));
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [slides.length]);

  const scrollToSlide = (index) => {
    const slideHeight = window.innerHeight - 70; // Account for header height
    window.scrollTo({
      top: index * slideHeight,
      behavior: 'smooth'
    });
  };

  return (
    <div className="homepage">
      {/* Navigation Dots */}
      <div className="nav-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`nav-dot ${index === activeSlide ? 'active' : ''}`}
            onClick={() => scrollToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Slideshow */}
      <main className="slideshow">
        {slides.map((slide, index) => (
          <section 
            key={slide.id} 
            className="slide"
            style={{
              backgroundImage: `url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="slide-overlay">
              <div className={`slide-content ${slide.textPosition} ${slide.id === 3 ? 'center' : ''}`}>
                <div className={`text-block ${slide.id === 3 ? 'final-slide' : ''}`}>
                  <h2>{slide.title}</h2>
                  {slide.description}
                  {slide.id === 3 && (
                    <div className="final-slide-nav">
                      <div className="nav-links">
                        <Link to="/about" className="nav-link">
                          <span className="nav-text">About Us</span>
                        </Link>
                        <Link to="/projects" className="nav-link">
                          <span className="nav-text">Our Projects</span>
                        </Link>
                        <Link to="/contact" className="nav-link">
                          <span className="nav-text">Contact</span>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        ))}
      </main>
    </div>
  );
};

export default Homepage;